import React, { useEffect, useState } from "react"
import { Link } from "react-router-dom"

import FilterForm from "./FilterForm"

import { CustomBootstrapTable, CustomButton } from "components/Common"
import { statusTypes, ModuleIds } from "constant/utility"

import { InlineAction } from "components/Common"
import { useSelector } from "react-redux"

import { indexCalculator } from "helpers/utilities"
import { exportExcelCompany } from "helpers/app-backend/companies_backend_helper"

//i18n
import { withTranslation } from "react-i18next"
import IconStatus from "components/Common/IconStatus"
const RESOURCE = ModuleIds.Company

const CompanyTable = ({
  onSelect,
  onSelectAll,
  companies,
  onSearch,
  onSort,
  onRefresh,
  onPageChange,
  paging,
  onSizePerPageChange,
  onSubmitFilter,
  onEdit,
  onDelete,
  loading,
  t,
  updatedTime,
}) => {
  const [data, setData] = useState([])
  const [model, setModel] = useState({
    search: "",
    companyType: [],
    isSystem: "",
  })

  const searchQuery = useSelector(state => state.company.searchQuery)

  const onResetHandler = () => {
    const initModel = {
      search: "",
      companyType: [],
      isSystem: "",
    }
    let x = document.getElementsByName("companyType")
    for (let i = 0; i < x.length; i++) {
      x[i].checked = false
    }
    setModel(initModel)
  }

  useEffect(() => {
    setModel(searchQuery)
  }, [searchQuery])

  useEffect(() => {
    setData(companies)
  }, [companies])

  const onExportExcel = async () => {
    const res = await exportExcelCompany(model)
    const blob = new Blob([res])
    const fileName = "Danh_sach_to_chuc.xlsx"
    saveAs(blob, fileName)
  }

  const columns = [
    {
      dataField: "id",
      text: "#",
      style: { width: 50 },
      formatter: (cellContent, company, index) => {
        return indexCalculator(paging.page, paging.size, index + 1)
      },
    },
    {
      dataField: "id",
      text: "#",
      hidden: true,
    },
    {
      dataField: "name",
      text: t("common:Name"),
      sort: true,
      formatter: (cellContent, company, index) => {
        return <Link to={`/Company/${company.id}/view?tab=1`}>{cellContent}</Link>
      },
    },
    {
      dataField: "remark",
      text: t("common:Note"),
      sort: true,
    },
    {
      dataField: "address",
      text: t("common:Address"),
      sort: true,
    },
    {
      dataField: "parentId",
      text: t("Parent Company"),
      sort: true,
      formatter: (cellContent, company, index) => {
        return <Link to={`#`}>{company.parentName}</Link>
      },
    },
    {
      dataField: "status",
      text: t("common:Status"),
      sort: true,
      align: 'center',
      headerAlign: 'center',
      formatter: (cellContent, company, index) => {
        return <IconStatus
          isRound={true}
          type={cellContent ? statusTypes.ACTIVE : statusTypes.INACTIVE}
        />
      },
    },
    {
      dataField: "action",
      text: "",
      isDummyField: true,
      style: { width: 50 },
      formatter: (cellContent, company, index) => (
        <InlineAction
          resource={RESOURCE}
          onEdit={e => onEdit(e, company.id)}
          onDelete={e => onDelete(e, company)}
        />
      ),
    },
  ]
  return (
    <CustomBootstrapTable
      columns={columns}
      search
      data={data}
      paging={paging}
      onSelect={onSelect}
      onSelectAll={onSelectAll}
      onSearch={onSearch}
      onSort={onSort}
      onRefresh={onRefresh}
      filterForm={() => <FilterForm model={model} />}
      onReset={onResetHandler}
      onPageChange={onPageChange}
      onSizePerPageChange={onSizePerPageChange}
      onSubmitFilter={onSubmitFilter}
      searchText={model.search}
      loading={loading}
      updatedTime={updatedTime}
      resource={RESOURCE}
      isImportExportButton={true}
      importExportForm={() =>
        <div className="tooltip-custom">
          <CustomButton
            isEdit
            color="secondary"
            outline
            onClick={onExportExcel}
          >
            <i className={"fas fa-download"}></i>
          </CustomButton>
          <span className="tooltiptext-custom-button-icon-left">
            {t("common:Export All")}
          </span>
        </div>
      }
    />
  )
}

export default withTranslation(["companyPage", "common"])(CompanyTable)
